import React from "react";
import { Button } from "@jem-open/jem-ui";
import { Menu } from "lucide-react";
import JemLogo from "../../common/assets/logo.webp";

interface MobileTopBarProps {
  onMenuClick: () => void;
  onHomeClick: () => void;
}

const MobileTopBar: React.FC<MobileTopBarProps> = ({
  onMenuClick,
  onHomeClick,
}) => (
  <div className="md:hidden sticky top-0 z-30 flex items-center justify-between gap-sm bg-secondary-pink-50 px-sm py-xxs mb-md">
    <button
      type="button"
      onClick={onHomeClick}
      aria-label="Go to home"
      className="flex items-center"
    >
      <img
        src={JemLogo}
        alt="Jem Logo"
        width={60}
        style={{ width: 60, height: "auto", display: "block" }}
      />
    </button>
    <Button
      variant="ghost"
      size="icon-lg"
      onClick={onMenuClick}
      aria-label="Open menu"
      className="text-secondary-pink-900 hover:bg-secondary-pink-100"
    >
      <Menu size={24} />
    </Button>
  </div>
);

export default MobileTopBar;
